import { Market, SelectionType, MarketIdToMarketType } from "../../data";
import { SelectionParser, SelectionSortFuncs } from "../SelectionParser";
export class MarketParser {
    constructor() {
        this.ExtractEachWayFromSelectionNameRegex = /E\/W \d+\/\d+ (\d+-{1})+(\d+)+/;
    }
    static get instance() {
        if (!MarketParser._instance) {
            MarketParser._instance = new MarketParser();
        }
        return MarketParser._instance;
    }
    parse(source, existingMarket, uiPreferences) {
        let existingSelections = (existingMarket ? existingMarket.selections : []);
        let marketType = (existingMarket ? existingMarket.typeId : source.marketType.id);
        return new Market({
            id: source.id,
            type: this.getMarketType(marketType),
            typeId: marketType,
            selections: source.selections.map((x) => SelectionParser.instance.parse(x, existingSelections.find(sel => sel.id === x.id), uiPreferences))
                .filter(x => !x.isDisabled && x.odds)
                .sort(SelectionSortFuncs.Sort(this.getMarketType(marketType))),
            name: source.name,
            eachWayText: existingMarket ? existingMarket.eachWayText : this.getEachWay(source),
            tags: source.tags
        });
    }
    getEachWay(market) {
        for (let index = 0; index < market.selections.length; index++) {
            let currentMatch = market.selections[index]
                .name.match(this.ExtractEachWayFromSelectionNameRegex);
            if (currentMatch !== null) {
                return currentMatch[0];
            }
        }
        return undefined;
    }
    getMarketType(marketType) {
        return MarketIdToMarketType[marketType] || SelectionType.QA;
    }
}
//# sourceMappingURL=MarketParser.js.map